import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Loading from "../../components/Loading/Loading";
import "../Booking/booking.css";
import ProgressBarLoader from "../../components/ProgressBarLoader/ProgressBarLoader";
import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt, FaDollarSign, FaLuggageCart, FaDog, FaCreditCard, FaCouch } from "react-icons/fa"; // Cambiado FaChair por FaCouch

const Booking = () => {
  const navigate = useNavigate();
  const [card, setCard] = useState({
    name: "",
    last_name: "",
    email: "",
    phone_number: "",
    amount: 0,
    description: "Venta de Boleto",
  });
  const [loading, setLoading] = useState(false);
  const [origin, setOrigin] = useState("");
  const [destination, setDestination] = useState("");
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [purchase_order, setPurchaseOrder] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [isRoundTrip, setIsRoundTrip] = useState(false);
  const [outboundData, setOutboundData] = useState(null);
  const [returnData, setReturnData] = useState(null);
  const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
  const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

  useEffect(() => {
    window.scrollTo(0, 0);
    const dataResume = JSON.parse(localStorage.getItem("dataResume"));
    
    // Verificar si es viaje redondo
    if (dataResume.isRoundTrip) {
      setIsRoundTrip(true);
      setOutboundData(dataResume.outbound);
      setReturnData(dataResume.return);
      setOrigin(dataResume.outbound.origin);
      setDestination(dataResume.outbound.destination);
      setData(dataResume.outbound.dataForm);
      setTotal(dataResume.outbound.total + dataResume.return.total);
      setPurchaseOrder(dataResume.outbound.purchase_order);
      setCard({ ...card, amount: dataResume.outbound.total + dataResume.return.total });
      setDate(dataResume.outbound.date);
      setTime(dataResume.outbound.time);
    } else {
      // Viaje simple
      setIsRoundTrip(false);
      const dataArray = Object.values(dataResume.dataForm);
      setOrigin(dataResume.origin);
      setDestination(dataResume.destination);
      setData(dataArray);
      setTotal(dataResume.total);
      setPurchaseOrder(dataResume.purchase_order);
      setCard({ ...card, amount: dataResume.total });
      setDate(dataResume.date);
      setTime(dataResume.time);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData();
    form.append("amount", total);
    form.append("name", data[0].name);
    form.append("last_name", data[0].last_name);
    form.append("email", data[0].email);
    form.append("phone_number", data[0].phone_number);
    form.append("description", "Venta de Boleto");
    form.append("purchase_order", purchase_order);
    setLoading(true);
    await axios
      .post(ENDPOINT + "payment", form)
      .then((response) => {
        localStorage.removeItem("dataResume");
        localStorage.removeItem("dataTrip");
        window.location.href = response.data.data;
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: '<div className="title-custom-alert">' + TITLEALERT + "</div>",
          showConfirmButton: true,
          html:
            '<div className="text-custom-alert">' +
            error.response.data.msg +
            "</div>",
          showClass: { popup: "animate__animated animate__fadeInDown" },
          hideClass: { popup: "animate__animated animate__fadeOutUp" },
        });
      });
  };

  const resetSearchTickets = async (purchaseOrders) => {
  if (!purchaseOrders || purchaseOrders.length === 0) return;

  try {
    await axios.post(ENDPOINT + "tickets/reset-search", {
      purchase_orders: purchaseOrders,
      user_id: 1,
    });
  } catch (error) {
    console.warn("Error calling reset-search endpoint", error);
  }
};

  const handleCancelTransaction = async () => {
  const result = await Swal.fire({
    title: "¿Cancelar transacción?",
    text: "Se marcarán los tickets como cancelados y volverás a la búsqueda.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sí, cancelar",
    cancelButtonText: "No",
  });

  if (!result.isConfirmed) return;

  setLoading(true);

  let purchaseOrders = [];

  if (isRoundTrip) {
    purchaseOrders = [
      outboundData?.purchase_order,
      returnData?.purchase_order,
    ];
  } else {
    purchaseOrders = [purchase_order];
  }

  // 🔥 Limpieza clave
  purchaseOrders = purchaseOrders
    .filter(Boolean) // elimina null/undefined
    .filter((v, i, arr) => arr.indexOf(v) === i); // elimina duplicados

  if (purchaseOrders.length === 0) {
    console.error("No hay purchase_orders válidos");
    setLoading(false);
    return;
  }

  await resetSearchTickets(purchaseOrders);

  setLoading(false);

  localStorage.removeItem("dataResume");
  localStorage.removeItem("dataTrip");

  Swal.fire({
    icon: "success",
    title: "Transacción cancelada",
    text: "Tu búsqueda ha sido reiniciada.",
    showConfirmButton: false,
    timer: 1500,
  });

  navigate("/");
};

  const formatTime = (time) => {
    const [hours, minutes] = time.split(':');
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const formatHour = hour % 12 || 12;
    return `${formatHour}:${minutes} ${ampm}`;
  };


  return (
    <>
      {loading && <Loading />}
      <ProgressBarLoader />
      <Breadcrumbs title="Realizar pago" pagename="Realizar pago" />
      <section className="booking-section py-5">
        <Container>
          <div className="alert alert-warning d-flex align-items-center mb-4 shadow-sm border-warning" 
               style={{
                 backgroundColor: '#fff3cd',
                 borderLeft: '5px solid #ffc107',
                 padding: '1rem 1.5rem'
               }}>
            <div className="d-flex align-items-center gap-3">
              <div className="alert-icon">
                <i className="bi bi-clock-history fs-3 text-warning"></i>
              </div>
              <div className="alert-content">
                <h4 className="alert-heading mb-1 d-flex align-items-center gap-2">
                  <i className="bi bi-exclamation-triangle-fill text-warning"></i>
                  Tiempo límite de pago
                </h4>
                <p className="mb-0">
                  Por favor, complete su pago dentro de los próximos <strong>25 minutos</strong>. 
                  Después de este tiempo, su reserva será cancelada automáticamente y los asientos volverán a estar disponibles.
                </p>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end mb-4">
            <button
              type="button"
              className="btn btn-danger btn-lg shadow-sm"
              onClick={handleCancelTransaction}
            >
              <i className="bi bi-x-circle me-2"></i>
              Cancelar transacción
            </button>
          </div>
          
          <Row>
            <Col md="8" lg="8">
              <Card className="card-info">
                <Card.Header className="d-flex align-items-center">
                  <FaUser className="header-icon me-2" />
                  <h1 className="h4 m-0">
                    Resumen pasajeros {isRoundTrip && "(Viaje Redondo)"}
                  </h1>
                </Card.Header>
                <Card.Body>
                  {isRoundTrip && outboundData && (
                    <>
                      <div className="mb-4">
                        <div className="alert alert-info">
                          <strong>
                            <i className="bi bi-arrow-right-circle me-2"></i>
                            VIAJE DE IDA
                          </strong>
                          <div className="small mt-2">
                            {outboundData.origin} → {outboundData.destination} |{" "}
                            {outboundData.date} {formatTime(outboundData.time)}
                          </div>
                        </div>
                        {outboundData.dataForm &&
                          outboundData.dataForm.map((item, index) => (
                            <div key={index} className="passenger-info">
                              <h2 className="h5 passenger-title">
                                <FaUser className="me-2" />
                                Pasajero #{index + 1}
                              </h2>
                              <div className="passenger-data">
                                <span className="passenger-label">
                                  <FaUser className="me-2" />
                                  Nombres:
                                </span>
                                <span>{item.name}</span>
                              </div>
                              <div className="passenger-data">
                                <span className="passenger-label">
                                  <FaUser className="me-2" />
                                  Apellidos:
                                </span>
                                <span>{item.last_name}</span>
                              </div>
                              <div className="passenger-data">
                                <span className="passenger-label">
                                  <FaEnvelope className="me-2" />
                                  Email:
                                </span>
                                <span>{item.email}</span>
                              </div>
                              <div className="passenger-data">
                                <span className="passenger-label">
                                  <FaPhone className="me-2" />
                                  Teléfono:
                                </span>
                                <span>{item.phone}</span>
                              </div>
                            </div>
                          ))}
                      </div>

                      <div>
                        <div className="alert alert-warning">
                          <strong>
                            <i className="bi bi-arrow-left-circle me-2"></i>
                            VIAJE DE VUELTA
                          </strong>
                          <div className="small mt-2">
                            {returnData.destination} → {returnData.origin} |{" "}
                            {returnData.date} {formatTime(returnData.time)}
                          </div>
                        </div>
                        {returnData.dataForm &&
                          returnData.dataForm.map((item, index) => (
                            <div key={index} className="passenger-info">
                              <h2 className="h5 passenger-title">
                                <FaUser className="me-2" />
                                Pasajero #{index + 1}
                              </h2>
                              <div className="passenger-data">
                                <span className="passenger-label">
                                  <FaUser className="me-2" />
                                  Nombres:
                                </span>
                                <span>{item.name}</span>
                              </div>
                              <div className="passenger-data">
                                <span className="passenger-label">
                                  <FaUser className="me-2" />
                                  Apellidos:
                                </span>
                                <span>{item.last_name}</span>
                              </div>
                              <div className="passenger-data">
                                <span className="passenger-label">
                                  <FaEnvelope className="me-2" />
                                  Email:
                                </span>
                                <span>{item.email}</span>
                              </div>
                              <div className="passenger-data">
                                <span className="passenger-label">
                                  <FaPhone className="me-2" />
                                  Teléfono:
                                </span>
                                <span>{item.phone}</span>
                              </div>
                            </div>
                          ))}
                      </div>
                    </>
                  )}
                  {!isRoundTrip &&
                    data.map((item, index) => (
                      <div key={index} className="passenger-info">
                        <h2 className="h5 passenger-title">
                          <FaUser className="me-2" />
                          Pasajero #{index + 1}
                        </h2>
                        <div className="passenger-data">
                          <span className="passenger-label">
                            <FaUser className="me-2" />
                            Nombres:
                          </span>
                          <span>{item.name}</span>
                        </div>
                        <div className="passenger-data">
                          <span className="passenger-label">
                            <FaUser className="me-2" />
                            Apellidos:
                          </span>
                          <span>{item.last_name}</span>
                        </div>
                        <div className="passenger-data">
                          <span className="passenger-label">
                            <FaEnvelope className="me-2" />
                            Email:
                          </span>
                          <span>{item.email}</span>
                        </div>
                        <div className="passenger-data">
                          <span className="passenger-label">
                            <FaPhone className="me-2" />
                            Teléfono:
                          </span>
                          <span>{item.phone}</span>
                        </div>
                      </div>
                    ))}
                </Card.Body>
              </Card>
            </Col>

            <Col md="4" lg="4">
              <Card className="card-info">
                <Card.Header className="d-flex align-items-center">
                  <FaDollarSign className="header-icon me-2" />
                  <h1 className="h4 m-0">Resumen de Precios</h1>
                </Card.Header>
                <Card.Body>
                  {isRoundTrip && outboundData && returnData ? (
                    <>
                      {/* VIAJE DE IDA */}
                      <div className="mb-4 pb-4 border-bottom">
                        <div className="alert alert-info mb-3">
                          <strong>
                            <i className="bi bi-arrow-right-circle me-2"></i>
                            IDA
                          </strong>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <strong><i className="bi bi-geo-fill me-2"></i>Origen</strong>
                          <span>{outboundData.origin}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <strong>
                            <FaMapMarkerAlt className="me-2" />
                            Destino
                          </strong>
                          <span>{outboundData.destination}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <strong><i className="bi bi-calendar3 me-2"></i>Fecha</strong>
                          <span>{outboundData.date}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <strong><i className="bi bi-clock me-2"></i>Hora</strong>
                          <span>{formatTime(outboundData.time)}</span>
                        </div>

                        <div className="price-details">
                          {outboundData.dataForm &&
                            outboundData.dataForm.map((item, index) => (
                              <div key={index} className="price-item mb-3">
                                <div className="d-flex justify-content-between">
                                  <span>
                                    <FaCouch className="me-2" />
                                    Asiento # {item.seat}
                                  </span>
                                  <strong>${item.price}</strong>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <span>
                                    <FaLuggageCart className="me-2" />
                                    Equipaje Extra
                                  </span>
                                  <strong>
                                    ${item.extraLuggage === 1 ? item.extraLuggageAmount : 0}
                                  </strong>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <span>
                                    <FaDog className="me-2" />
                                    Mascota
                                  </span>
                                  <strong>
                                    ${item.pet === 1 ? item.petAmount : 0}
                                  </strong>
                                </div>
                              </div>
                            ))}
                        </div>
                        <div className="d-flex justify-content-between pt-3 border-top">
                          <strong>Subtotal IDA</strong>
                          <strong>${outboundData.total}</strong>
                        </div>
                      </div>

                      {/* VIAJE DE VUELTA */}
                      <div className="mb-4">
                        <div className="alert alert-warning mb-3">
                          <strong>
                            <i className="bi bi-arrow-left-circle me-2"></i>
                            VUELTA
                          </strong>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <strong><i className="bi bi-geo-fill me-2"></i>Origen</strong>
                          <span>{returnData.destination}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <strong>
                            <FaMapMarkerAlt className="me-2" />
                            Destino
                          </strong>
                          <span>{returnData.origin}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <strong><i className="bi bi-calendar3 me-2"></i>Fecha</strong>
                          <span>{returnData.date}</span>
                        </div>
                        <div className="d-flex justify-content-between mb-3">
                          <strong><i className="bi bi-clock me-2"></i>Hora</strong>
                          <span>{formatTime(returnData.time)}</span>
                        </div>

                        <div className="price-details">
                          {returnData.dataForm &&
                            returnData.dataForm.map((item, index) => (
                              <div key={index} className="price-item mb-3">
                                <div className="d-flex justify-content-between">
                                  <span>
                                    <FaCouch className="me-2" />
                                    Asiento # {item.seat}
                                  </span>
                                  <strong>${item.price}</strong>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <span>
                                    <FaLuggageCart className="me-2" />
                                    Equipaje Extra
                                  </span>
                                  <strong>
                                    ${item.extraLuggage === 1 ? item.extraLuggageAmount : 0}
                                  </strong>
                                </div>
                                <div className="d-flex justify-content-between">
                                  <span>
                                    <FaDog className="me-2" />
                                    Mascota
                                  </span>
                                  <strong>
                                    ${item.pet === 1 ? item.petAmount : 0}
                                  </strong>
                                </div>
                              </div>
                            ))}
                        </div>
                        <div className="d-flex justify-content-between pt-3 border-top">
                          <strong>Subtotal VUELTA</strong>
                          <strong>${returnData.total}</strong>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="price-summary mb-4">
                      <div className="d-flex justify-content-between mb-3">
                        <strong><i className="bi bi-geo-fill me-2"></i>Origen</strong>
                        <span>{origin}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-3">
                        <strong><FaMapMarkerAlt className="me-2" />Destino</strong>
                        <span>{destination}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-3">
                        <strong><i className="bi bi-calendar3 me-2"></i>Fecha</strong>
                        <span>{date}</span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <strong><i className="bi bi-clock me-2"></i>Hora</strong>
                        <span>{formatTime(time)}</span>
                      </div>
                    </div>
                  )}
                </Card.Body>
                <Card.Footer className="d-flex flex-column align-items-center py-4">
                  <div className="d-flex justify-content-between w-100 mb-4">
                    <span className="h5 mb-0 d-flex align-items-center">
                      <FaDollarSign className="me-2" />
                      Total a Pagar
                    </span>
                    <strong className="total-price">${total}</strong>
                  </div>
                  <form onSubmit={handleSubmit} className="w-100 text-center">
                    <button type="submit" className="primaryBtn w-100 mb-3">
                      <FaCreditCard className="me-2" />
                      Proceder al pago
                    </button>
                  </form>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Booking;
